import type { MouseEvent as ReactMouseEvent, ReactNode } from 'react';

import { useOpenDrawer } from '../../../hooks/drawer';

interface UseDisclaimerDrawerOptions {
  content: string | ReactNode;
  onClick?: () => void;
}

export const useDisclaimerDrawer = ({ content, onClick }: UseDisclaimerDrawerOptions) => {
  const isReactNode = typeof content !== 'string';
  const openDrawer = useOpenDrawer(isReactNode ? { content } : { html: content }, {
    preventDefault: true,
  });

  const handleClick = (e: ReactMouseEvent) => {
    e.stopPropagation();
    e.preventDefault();

    if (onClick) onClick();

    openDrawer();
  };

  return handleClick;
};
